import { render, staticRenderFns } from "./AccountsPaymentForm.vue?vue&type=template&id=535161be&"
import script from "./AccountsPaymentForm.vue?vue&type=script&lang=ts&"
export * from "./AccountsPaymentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports